import { render, staticRenderFns } from "./financial.vue?vue&type=template&id=2351c356&scoped=true&"
import script from "./financial.vue?vue&type=script&lang=js&"
export * from "./financial.vue?vue&type=script&lang=js&"
import style0 from "./financial.vue?vue&type=style&index=0&id=2351c356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351c356",
  null
  
)

export default component.exports